import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed top-0 inset-x-0 pt-2 lg:pb-5 z-30" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-2 lg:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "order-3 flex-shrink-0 w-full lg:order-2 lg:mt-0 lg:w-auto" }
const _hoisted_5 = { class: "order-2 flex-shrink-0 lg:order-3 lg:ml-2" }
const _hoisted_6 = {
  type: "button",
  class: "-mr-1 flex p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-white"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

import { TransitionRoot } from '@headlessui/vue'
import { ref } from 'vue'
import type { BannerExports } from '@/types/ui'
import type { ShowBannerNotificationObject } from '@/utils/notifications'
import { ENotificationType } from '@/utils/notifications'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheBanner',
  setup(__props, { expose }) {

const isVisible = ref(false)
const message = ref('')
const type = ref<ENotificationType>(ENotificationType.error)

let timeout = 0
const kHideTime = 5000

/* eslint-disable @typescript-eslint/no-magic-numbers */

function show(object?: ShowBannerNotificationObject): void {
  type.value = object?.type ?? ENotificationType.error
  message.value = object?.message ?? ''
  isVisible.value = true

  timeout = window.setTimeout(() => {
    isVisible.value = false
  }, kHideTime)
}

function hide(): void {
  clearTimeout(timeout)
  isVisible.value = false
}

/* eslint-enable */

expose<BannerExports>({
  show,
  hide
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    show: isVisible.value,
    enter: "transition ease-in-out duration-300 transform",
    "enter-from": "-translate-y-20 opacity-0",
    "enter-to": "translate-y-0 opacity-100",
    leave: "transition ease-in-out duration-300 transform",
    "leave-from": "translate-y-0 opacity-100",
    "leave-to": "-translate-y-20 opacity-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["p-2 rounded-lg shadow-lg lg:p-3", [
            { 'bg-red-400  text-white': type.value === _unref(ENotificationType).error },
            { 'bg-project-primary text-white': type.value === _unref(ENotificationType).info },
            { 'bg-green-500 text-white': type.value === _unref(ENotificationType).success },
            { 'bg-slate-900 bg-opacity-95': type.value === _unref(ENotificationType).warning }
          ]])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(message.value), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", _hoisted_6, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: "h-6 w-6 text-white",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "2",
                    stroke: "currentColor",
                    "aria-hidden": "true",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isVisible.value = false))
                  }, _hoisted_8))
                ])
              ])
            ])
          ], 2)
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})